import { SVGProps, Ref, forwardRef } from 'react';

export const HomeOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.374.5 16 5.128l-.004 5.042c0 3.999-1.333 5.332-5.332 5.332H5.332C1.333 15.5 0 14.168 0 10.169V5.666L4.666.501zm-1.343 6.066h4.565v3.603c0 1.922-.338 2.758-.756 3.175-.418.418-1.254.757-3.176.757h-.633zm-1.4-.12L4.717 2.532 1.4 6.205v3.964c0 1.922.339 2.758.757 3.175.418.418 1.253.757 3.175.757h3.3zm5.429-1.28-3.266-3.265H6.066L9.33 5.166z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
HomeOutlinedSize16Glyph.displayName = 'HomeOutlinedSize16Glyph';
